import { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

type SupportedLang = "en" | "fr";

interface LanguageContextValue {
  lang: SupportedLang;
  setLang: (l: SupportedLang) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  lang: "en",
  setLang: () => {},
});

export function useLanguage() {
  return useContext(LanguageContext);
}

function getInitialLang(): SupportedLang {
  if (typeof window === "undefined") return "en";
  const saved = localStorage.getItem("malariaguard-lang") as SupportedLang | null;
  if (saved === "en" || saved === "fr") return saved;
  return "en";
}

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const [lang, setLangState] = useState<SupportedLang>(getInitialLang);

  useEffect(() => {
    i18n.changeLanguage(lang);
    localStorage.setItem("malariaguard-lang", lang);
  }, [lang, i18n]);

  const setLang = (l: SupportedLang) => setLangState(l);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}